import React, {
  useCallback,
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle
} from "react";
import PropTypes from "prop-types";
import { MODAL_TYPE } from "./constants";
import { Icon } from "../../shared-components";

const Modal = forwardRef(({ id, children, onClose }, ref) => {
  const [isOpen, setisOpen] = useState(false);

  const show = useCallback(
    () => {
      // Close any other open modal
      if (window.wattpad.modals && !isOpen) {
        _.each(window.wattpad.modals, (val, key) => {
          const modal = window.wattpad.modals[key];
          if (modal.id != id && modal.isOpen())
            window.wattpad.modals[key].hide();
        });
      }

      document.body.classList.add("modal-open");
      setisOpen(true);
    },
    [id, isOpen, setisOpen]
  );

  const hide = useCallback(
    () => {
      document.body.classList.remove("modal-open");
      setisOpen(false);
    },
    [setisOpen]
  );

  const onEscapeKey = useCallback(e => e.key === "Escape" && hide(), [hide]);

  useImperativeHandle(ref, () => ({ isOpen, hide, show }));

  useEffect(
    () => {
      window.wattpad.utils.registerModal(id, MODAL_TYPE.DS_MODAL, {
        isOpen: () => isOpen,
        show,
        hide
      });

      if (isOpen) {
        window.addEventListener("tap", onEscapeKey);
        window.addEventListener("keydown", onEscapeKey);

        return () => {
          window.removeEventListener("tap", onEscapeKey);
          window.removeEventListener("keydown", onEscapeKey);
        };
      }
    },
    [id, isOpen, show, hide, onEscapeKey]
  );

  const handleClose = () => {
    onClose && onClose();
    hide();
  };

  return isOpen ? (
    <>
      <div id={`${id}-overlay`} className="modal-overlay" />
      <div id={id} className="modal-wrapper">
        <div className="modal-container">
          {children}
          <button
            type="button"
            className="modal-close-button"
            onClick={handleClose}
          >
            <Icon
              className="modal-close-icon"
              name="modalClose"
              size={14}
              strokeWidth="0"
              fillColor="ds-neutral-80"
              viewBox={14}
              aria-hidden
            />
          </button>
        </div>
      </div>
    </>
  ) : null;
});
Modal.displayName = "Modal";

Modal.propTypes = {
  id: PropTypes.string.isRequired,
  children: PropTypes.any,
  onClose: PropTypes.func
};

export default Modal;
